/**
 * File: src/components/admin-login-modal.js
 * Mô tả: Component Popup Đăng Nhập Admin (Admin Login Modal) hiển thị khi chưa xác thực tài khoản.
 * Liên quan: src/services/admin-auth-service.js, src/pages/admin-page.js
 */

import { createElement } from '../utils/dom.js';
import { loginAdmin } from '../services/admin-auth-service.js';

export const renderAdminLoginModal = (onLoginSuccess) => {
  const overlay = createElement('div', {
    className: 'admin-login-overlay',
    attributes: {
      style: 'position: fixed; inset: 0; background: rgba(5, 7, 15, 0.85); backdrop-filter: blur(12px); z-index: 9999; display: flex; align-items: center; justify-content: center; padding: 1.5rem;',
    },
  });

  const card = createElement('div', {
    className: 'admin-login-card',
    attributes: {
      style: 'background: var(--bg-tertiary); width: 100%; max-width: 420px; padding: 2.25rem; border-radius: var(--radius-lg); border: var(--border-neon); box-shadow: 0 20px 50px rgba(0, 0, 0, 0.7); position: relative;',
    },
  });

  card.innerHTML = `
    <div style="text-align: center; margin-bottom: 1.75rem;">
      <div style="display: inline-flex; align-items: center; gap: 0.5rem; background: rgba(16, 185, 129, 0.15); border: 1px solid var(--color-success); padding: 6px 14px; border-radius: var(--radius-full); color: var(--color-success); font-size: 0.8rem; font-weight: 600; margin-bottom: 1rem;">
        🛡️ Cloudflare Zero Trust Protected
      </div>
      <h2 style="font-size: 1.75rem; margin-bottom: 0.5rem;">Cổng Đăng Nhập Admin</h2>
      <p style="font-size: 0.85rem; color: var(--color-text-muted);">Vui lòng đăng nhập tài khoản quản trị để truy cập giao diện biên tập cấu hình game SNT Games.</p>
    </div>

    <form id="admin-login-form">
      <div style="margin-bottom: 1.25rem;">
        <label style="display: block; font-size: 0.85rem; color: var(--color-text-muted); margin-bottom: 0.35rem;">Tài khoản (Username)</label>
        <input type="text" id="login-username" placeholder="Nhập tên đăng nhập admin..." required style="width: 100%; padding: 12px; border-radius: 8px; background: var(--bg-primary); border: var(--border-glass); color: #fff; outline: none; font-size: 0.95rem;" />
      </div>

      <div style="margin-bottom: 1.25rem;">
        <label style="display: block; font-size: 0.85rem; color: var(--color-text-muted); margin-bottom: 0.35rem;">Mật khẩu (Password)</label>
        <input type="password" id="login-password" placeholder="••••••••••••" required style="width: 100%; padding: 12px; border-radius: 8px; background: var(--bg-primary); border: var(--border-glass); color: #fff; outline: none; font-size: 0.95rem;" />
      </div>

      <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 1.5rem; font-size: 0.85rem;">
        <label style="display: flex; align-items: center; gap: 0.5rem; cursor: pointer; color: var(--color-text-muted);">
          <input type="checkbox" id="login-remember" style="width: 16px; height: 16px; cursor: pointer;" />
          <span>Ghi nhớ phiên đăng nhập</span>
        </label>
      </div>

      <div id="login-alert" style="margin-bottom: 1.25rem; display: none; padding: 10px; border-radius: 6px; background: rgba(239, 68, 68, 0.15); border: 1px solid var(--color-error); color: var(--color-error); font-size: 0.85rem; text-align: center;"></div>

      <button type="submit" id="login-submit-btn" class="btn btn-primary" style="width: 100%; padding: 12px; font-size: 1rem;">
        <span>🔒 Đăng Nhập Cổng Admin</span>
      </button>
    </form>
  `;

  const form = card.querySelector('#admin-login-form');
  const userInput = card.querySelector('#login-username');
  const passInput = card.querySelector('#login-password');
  const rememberInput = card.querySelector('#login-remember');
  const alertEl = card.querySelector('#login-alert');
  const submitBtn = card.querySelector('#login-submit-btn');

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const username = userInput.value.trim();
    const password = passInput.value.trim();

    if (!username || !password) return;

    submitBtn.disabled = true;
    submitBtn.innerHTML = '<span>⏳ Đang xác thực Server...</span>';
    alertEl.style.display = 'none';

    const result = await loginAdmin(username, password, rememberInput.checked);

    submitBtn.disabled = false;
    submitBtn.innerHTML = '<span>🔒 Đăng Nhập Cổng Admin</span>';

    if (result.success) {
      overlay.remove();
      if (onLoginSuccess) onLoginSuccess();
    } else {
      alertEl.style.display = 'block';
      alertEl.textContent = result.message || 'Đăng nhập không thành công.';
    }
  });

  overlay.appendChild(card);
  return overlay;
};
